<template>
  <v-card id="card-modal-assign-driver" class="elevation-4">
    <v-card-title class="justify-start py-2 card-modaltitle">
      <div class="pl-4">
        <h3 class="primary--text pl-4">
          {{ $t("components.views.trip.offers.transport_company.modal_details.detail") }}
        </h3>
      </div>
      <v-btn depressed icon color="primary" class="cont" @click.stop="$emit('closeForm')">
        <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-tabs v-model="tab" fixed-tabs>
              <v-tabs-slider color="secondary"></v-tabs-slider>
              <v-tab href="#Details" active-class="primary white--text">
                <v-icon size="14" class="mr-2">fa-solid fa-info-circle</v-icon>
                {{
                  $t(
                    "components.views.trip.offers.transport_company.modal_details.general_information"
                  )
                }}
              </v-tab>
              <v-tab href="#DetailsStop" active-class="primary white--text">
                <v-icon size="14" class="mr-2">fa-solid fa-info-circle</v-icon>
                {{
                  $t("components.views.trip.offers.transport_company.modal_details.stops_detail")
                }}
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
      <v-tabs-items v-model="tab">
        <v-tab-item value="Details">
          <v-card id="details_stop">
            <v-container fluid class="pt-2 mt-0">
              <v-row no-gutters class="mb-0 pb-0">
                <v-col md="4">
                  <strong>
                    {{
                      $t("components.views.trip.offers.transport_company.modal_details.weight")
                    }}:</strong>
                </v-col>
                <v-col md="8"> {{ weightDisplay }} </v-col>
              </v-row>
              <v-row no-gutters class="mb-0 pb-0">
                <v-col md="4">
                  <strong>
                    {{
                      $t("components.views.trip.offers.transport_company.modal_details.volume")
                    }}:</strong>
                </v-col>
                <v-col md="8"> {{ volumeDisplay }} </v-col>
              </v-row>
              <v-row no-gutters class="mb-0 pb-0">
                <v-col md="4">
                  <strong>
                    {{
                      $t("components.views.trip.offers.transport_company.modal_details.doc_ref1")
                    }}:</strong>
                </v-col>
                <v-col md="8"> {{ doc_ref1 }} </v-col>
              </v-row>
              <v-row no-gutters class="mb-0 pb-0">
                <v-col md="4">
                  <strong>
                    {{
                      $t("components.views.trip.offers.transport_company.modal_details.doc_ref2")
                    }}:</strong>
                </v-col>
                <v-col md="8"> {{ doc_ref2 }} </v-col>
              </v-row>
              <v-row no-gutters class="mb-0 pb-0">
                <v-col md="4">
                  <strong>
                    {{
                      $t("components.views.trip.offers.transport_company.modal_details.observations")
                    }}:</strong>
                </v-col>
                <v-col md="8"> {{ observations }} </v-col>
              </v-row>
              <v-row no-gutters class="mb-0 pb-0">
                <v-col md="4">
                  <strong>
                    {{
                      $t("components.views.trip.offers.transport_company.modal_details.description_type_operation")
                    }}:</strong>
                </v-col>
                <v-col md="8"> {{ descriptionTypeOperation }} </v-col>
              </v-row>
              <v-row no-gutters class="mb-0 pb-0">
                <v-col md="4">
                  <strong>
                    {{
                      $t("components.views.trip.offers.transport_company.modal_details.description_type_travel")
                    }}:</strong>
                </v-col>
                <v-col md="8"> {{ descriptionTypeTravel }} </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item value="DetailsStop">
          <v-card id="details_stop ">
            <v-container fluid class="pa-4 mt-0">
              <v-row no-gutters class="mb-0 pb-0">
                <v-spacer />
                <v-col md="12" class="mr-2 mb-0 pb-0">
                  <v-text-field prepend-icon="fa-solid fa-magnifying-glass" outlined hide-details dense
                    v-model="searchStops" clearable @keydown.enter="onSearch" @click:clear="cleanField()" :label="$t('components.views.trip.offers.transport_company.modal_details.search')
                      " :placeholder="$t(
                        'components.views.trip.offers.transport_company.modal_details.search_placeholder'
                      )
                        " />
                </v-col>
              </v-row>
              <v-container id="content-stop" class="mt-1">
                <v-row v-if="!loaderStops && stops.length > 0" id="row-result">
                  <v-col cols="12" class="pt-0">
                    <v-timeline align-top dense v-if="!showProducts">
                      <v-timeline-item color="primary" fill-dot v-for="(stop, i) in stops" :key="i">
                        <template slot="icon">
                          <v-icon color="white" v-if="i == 0">$vuetify.icons.custom.Envio </v-icon>
                          <v-icon color="white" v-if="i !== 0">$vuetify.icons.custom.Entrega
                          </v-icon>
                        </template>
                        <v-row class="pt-1">
                          <v-col cols="3">
                            <label>
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.date"
                                )
                              }}:</b>
                              {{ formatDate(stop.scheduleDate) }}
                            </label>
                            <p>
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.hour"
                                )
                              }}:</b>
                              {{ formatTime(stop.scheduleDate) }}
                            </p>
                          </v-col>
                          <v-col class="pa-2">
                            <strong>{{ stop.customer }}</strong>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.address"
                                )
                              }}:</b>
                              {{ stop.address }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.city"
                                )
                              }}:</b>
                              {{ stop.city }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.location"
                                )
                              }}:</b>
                              {{ stop.location }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.number_order"
                                )
                              }}:</b>
                              {{ stop.numberOrder }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.shipment_number"
                                )
                              }}:</b>
                              {{ stop.shipmentNumber }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.remission"
                                )
                              }}:</b>
                              {{ stop.remission }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.business_unit"
                                )
                              }}:</b>
                              {{ stop.businessUnit }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.sales_channel"
                                )
                              }}:</b>
                              {{ stop.salesChannel }}
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.description_type_commodity"
                                )
                              }}:</b>
                              <span class="ml-2">{{ stop.descriptionTypeCommodity }}</span>
                            </div>
                            <div class="text-caption">
                              <b>{{
                                $t(
                                  "components.views.trip.offers.transport_company.modal_details.description_zone"
                                )
                              }}:</b>
                              <span class="ml-2">{{ stop.descriptionZone }}</span>
                            </div>
                            <div v-if="stop.products && stop.products.length > 0" class="mt-2">
                              <v-btn @click="toggleProducts(stop.products)" class="px-4 py-1" small
                                style="background-color: rgb(29, 27, 89); border-color: rgb(29, 27, 89); color: rgb(255, 255, 255);">
                                {{
                                  $t(
                                    "components.views.trip.offers.transport_company.modal_details.products"
                                  )
                                }}
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-timeline-item>
                    </v-timeline>
                    <v-row v-if="showProducts" class="mt-1">
                      <v-col cols="12" class="pa-3">
                        <div v-for="(product, pIndex) in productsToShow" :key="pIndex" class="mb-4">
                          <div class="text-caption">
                            <b>{{
                              $t(
                                "components.views.trip.offers.transport_company.modal_details.description_product"
                              )
                            }}:</b>
                            <span class="ml-2">{{ product.descriptionProduct }}</span>
                          </div>
                          <div class="text-caption">
                            <b>{{
                              $t(
                                "components.views.trip.offers.transport_company.modal_details.barcode"
                              )
                            }}:</b>
                            <span class="ml-2">{{ product.barcode }}</span>
                          </div>
                          <div class="text-caption">
                            <b>{{
                              $t(
                                "components.views.trip.offers.transport_company.modal_details.unit"
                              )
                            }}:</b>
                            <span class="ml-2">{{ product.unit }}</span>
                          </div>
                          <div class="text-caption">
                            <b>{{
                              $t(
                                "components.views.trip.offers.transport_company.modal_details.routing_variable"
                              )
                            }}:</b>
                            <span class="ml-2">{{ product.routingVariable }}</span>
                          </div>
                          <v-divider class="my-3" />
                        </div>
                        <div class="mt-4">
                          <v-btn @click="showProducts = false" color="primary" dark class="px-4 py-2">
                            {{
                              $t(
                                "components.views.trip.offers.transport_company.modal_details.back_to_stops"
                              )
                            }}
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-if="loaderStops">
                  <v-col cols="12" class="pt-0">
                    <v-skeleton-loader v-for="index in 4" :key="index" type="list-item-avatar-three-line" />
                  </v-col>
                </v-row>
                <v-row v-if="stops.length == 0 && !loaderStops">
                  <v-col cols="12" align="center" justify="center">
                    <div id="no-result">
                      <v-icon>fa-solid fa-triangle-exclamation</v-icon>
                      <p>
                        <b>{{
                          $t(
                            "components.views.trip.offers.transport_company.modal_details.no_result"
                          )
                        }}</b>
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
              <v-divider />
              <div class="informacion-page">
                {{ info }}
              </div>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import validate from "@/plugins/validate";
import { mapActions } from "vuex";

export default {
  props: {
    idMonitoringOrder: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ...validate,
      tab: "Details",
      stops: [],
      searchStops: "",
      pageStops: 0,
      indexTable: 0,
      weight: "",
      volume: "",
      doc_ref1: "",
      doc_ref2: "",
      observations: "",
      descriptionTypeOperation: "",
      descriptionTypeTravel: "",
      loaderStops: false,
      totalCount: 0,
      resultForPageStops: 20,
      showProducts: false,
      productsToShow: [],
    };
  },
  computed: {
    headersLicensePlate() {
      return [
        {
          text: this.$t(
            "components.views.trip.offers.transport_company.modal_details.table_plate.license_plate"
          ),
          align: "center",
          class: "text-center",
          value: "licensePlate",
        },
      ];
    },
    info() {
      return this.totalCount > 0
        ? `${this.$t(
          "components.views.trip.offers.transport_company.modal_details.items_displayed"
        )}: ${this.totalCount}`
        : "";
    },
    urlStops() {
      return `/Travels/Stops/${this.idMonitoringOrder}/${this.resultForPageStops}/${this.pageStops}`;
    },
    urlWeight() {
      return `/Offers/DetailOfferInformation?idMonitoringOrder=${this.idMonitoringOrder}`;
    },
    urlStopsCount() {
      return `/Travels/CountStops/${this.idMonitoringOrder}`;
    },
    weightDisplay() {
      if (
        this.weight === null ||
        this.weight === undefined ||
        this.weight === "" ||
        this.weight === 0
      ) {
        return "";
      }
      return `${this.weight} Kg`;
    },
    volumeDisplay() {
      if (
        this.volume === null ||
        this.volume === undefined ||
        this.volume === "" ||
        this.volume === 0
      ) {
        return "";
      }
      return `${this.volume} m³`;
    },
  },
  watch: {
    searchStops(newValue) {
      if (!newValue) {
        this.cleanField();
      }
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),

    formatDate(dateTimeString) {
      if (!dateTimeString) return "";
      // Formato: "08/01/2026 17:11:35" -> "08/01/2026"
      return dateTimeString.split(" ")[0];
    },

    formatTime(dateTimeString) {
      if (!dateTimeString) return "";
      // Formato: "08/01/2026 17:11:35" -> "17:11:35"
      return dateTimeString.split(" ")[1] || "";
    },
    toggleProducts(products) {
      this.showProducts = true;
      this.productsToShow = products;
    },

    async loadData() {
      this.loaderStops = true;

      await this.axios
        .get(`${this.urlWeight}`)
        .then((response) => {
          this.weight = response.data.weight;
          this.volume = response.data.volume;
          this.doc_ref1 = response.data.doc_ref1;
          this.doc_ref2 = response.data.doc_ref2;
          this.observations = response.data.observations;
          this.descriptionTypeOperation = response.data.descriptionTypeOperation;
          this.descriptionTypeTravel = response.data.descriptionTypeTravel;
        })
        .catch((error) => { });

      const searchVal = this.searchStops == "" ? "" : `?search=${this.searchStops}`;

      await this.axios
        .get(`${this.urlStops}${searchVal}`)
        .then((response) => {
          this.stops = response.data;
        })
        .catch((error) => {
          this.showSnack({
            text: error.response.data,
            title: "Error",
            name: "error",
          });
        })
        .finally(() => {
          this.loaderStops = false;
        });

      if (this.loaderStops) {
        await this.axios
          .get(`${this.urlStopsCount}${searchVal}`)
          .then((response) => {
            this.totalCount = response.data;
          })
          .catch((error) => {
            this.showSnack({
              text: error.response.data,
              title: "Error",
              name: "error",
            });
          })
          .finally(() => {
            this.loaderStops = false;
          });
      }
    },

    cleanField() {
      this.pageStops = 0;
      this.searchStops = "";
      this.loadData();
    },

    onSearch() {
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ModalDetailsStyle.scss';
</style>
